let autoTable = (Vue) => {
  let resize = function (el, binding) {
    let $wrap = el.querySelector('.el-table__body-wrapper')
    let $item = $wrap
    let windowHeight = document.documentElement.clientHeight
    let distance = 0
    let offsetBottom = binding.value || 100
    let rect = $item.getBoundingClientRect()
    let iTop = rect.top
    let $fixdItem = el.querySelector('.el-table__fixed-body-wrapper')
    /* let iTop = $wrap.offsetTop
    while($wrap = $wrap.offsetParent){
      iTop += $wrap.offsetTop
    } */
    // 兼容滚动条
    let disOffsetB = windowHeight - iTop - el.clientHeight
    let scrollBarWidth = $item.offsetHeight - $item.clientHeight
    let $head = el.querySelectorAll('.el-table__header')[1]
    let patch = el.querySelector('.el-table__fixed-right-patch')
    let gutter = el.querySelector('[name=gutter]')
    let $right = el.querySelector('.el-table__fixed-right')
    if (patch) {
      patch.style.width = scrollBarWidth + 'px'
      patch.style.top = '0px'
    }
    if (gutter) {
      gutter.style.width = scrollBarWidth + 'px'
    }
    distance = windowHeight - iTop - offsetBottom
    if (distance <= 0) {
      distance = 0
    }
    if ($head) {
      $head.style.width = ($head.clientWidth- scrollBarWidth) + 'px'
    }
    el.querySelectorAll('.el-table__body').forEach(item => {
      item.style.width = (item.clientWidth - scrollBarWidth) + 'px'
    })
    if ($right) {
      $right.style.right = scrollBarWidth + 'px'
    }
    //
    if ($fixdItem) {
      $fixdItem.style['height'] = (distance) + 'px'
    }
    $item.style['height'] = (distance + scrollBarWidth) + 'px'
    $item.style['overflow-y'] = 'auto'
  }
  let tableObj = {
    bind: function (el, binding) {
      setTimeout(() => { resize(el, binding) }, 0)
      window.addEventListener('resize', () => { resize(el, binding)}, { passive: false })
    },
    inserted (el, binding) {
    },
    update: function (el, binding) {
    },
    unbind: function (el, binding) {
      window.removeEventListener('resize', () => { resize(el, binding)}, { passive: false })
    }
  }
  Vue.directive('auto-table', tableObj)
}
export default autoTable



// WEBPACK FOOTER //
// ./src/components/mc-ui/auto-table/index.js